export default "__VITE_ASSET__0d4ea3c7__"